import { Injectable } from '@angular/core';
import { UserModel } from '@libs/account/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({
  providedIn: 'root',
})
export class AgentRepositoryService {
  public constructor(
    private readonly connector: ConnectorService,
  ) {
  }

  public search(filter: string, page: number = 1, pageSize: number = 10): Observable<UserModel[]> {
    return this.connector.connect('agent', 'search',
      {
        searchParams: {
          filter, page, pageSize,
        },
      });
  }
}
